export default "/images/8ad060c5eb108fb344df2c7f48f6365a.png";